//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Libref",1,0],[0,"SaveFlag",1,0],[0,"TargetClass",1,0]],[[["attributes","values"],"SetAttributeAndValue",{},2,0],[[],"Export",{},0,0],[["saveFlag","replaceLibref","classNum"],"GetValidTargetClasses",{R_:{classes:""}},2,0],[["targetClass","attrNum"],"GetValidAttributes",{R_:{attributes:""}},1,0],[["attr","valueNum","valueIds","valueTexts"],"GetValidValuesOfAttribute",{},1,0]],[]];
SPLM.CAM.MultiToolExport = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MultiToolExport";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MultiToolExport.SaveFlags = Object.freeze({
    "Replace" : "Replace", "CreateNew" : "CreateNew"});

export default SPLM;